"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.telegramTargetFragmentDependencies = exports.telegramTargetFragment = void 0;
exports.telegramTargetFragment = `
fragment telegramTargetFragment on TelegramTarget {
  id
  isConfirmed
  name
  telegramId
  confirmationUrl
}
`.trim();
exports.telegramTargetFragmentDependencies = [];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVsZWdyYW1UYXJnZXRGcmFnbWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9mcmFnbWVudHMvdGVsZWdyYW1UYXJnZXRGcmFnbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHNCQUFzQixHQUFHOzs7Ozs7OztDQVFyQyxDQUFDLElBQUksRUFBRSxDQUFDO0FBRUksUUFBQSxrQ0FBa0MsR0FBRyxFQUFFLENBQUMifQ==